import { render, staticRenderFns } from "./FmBtn.vue?vue&type=template&id=73b06bd9&"
import script from "./FmBtn.vue?vue&type=script&lang=js&"
export * from "./FmBtn.vue?vue&type=script&lang=js&"
import style0 from "./FmBtn.vue?vue&type=style&index=0&id=73b06bd9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports